import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
})
export class ToggleSwitchComponent implements OnInit {
  protected switchId!: string;

  constructor() {}

  ngOnInit() {
    this.switchId = this.generateUniqueId();
  }

  private generateUniqueId(): string {
    return typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? `toggle-switch-${crypto.randomUUID()}`
      : `toggle-switch-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
  }
}
